import * as React from "react";
import Select from "react-select";
import { Edit16 } from "@carbon/icons-react";

import { AssetTypes, assetTypeToStrMap } from "@eave/shared/types/api";
import { EMDASH } from "./shared";

const EMPTY_ACCOUNT_TYPE = (
  <span className="asset-summary__empty-account-type">Please select type</span>
);

interface AccountTypeSelectorProps {
  type: AssetTypes;
  revisedType: AssetTypes;
  ignored: boolean;
  onUpdate: Function;
}

// right now block switching to negative asset type after asset added
// because of complications around how to flip the sign on the front-end
const revisedTypeOptions = Object.keys(AssetTypes)
  .map((type: AssetTypes) => {
    return type === AssetTypes.NegativeAsset
      ? null
      : { value: type, label: assetTypeToStrMap[type] };
  })
  .filter(Boolean);

export default class AccountTypeSelector extends React.Component<AccountTypeSelectorProps, any> {
  constructor(props: AccountTypeSelectorProps) {
    super(props);
    this.state = { editing: false };
  }

  onChange = e => {
    this.toggleEditing(false);
    this.props.onUpdate(e);
  };

  toggleEditing(bool: boolean) {
    this.setState({ editing: bool });
  }

  renderRevisedType() {
    const { type, revisedType, ignored } = this.props;
    const { editing } = this.state;

    if (editing) {
      return (
        <div className="acct-attr-override__editor acct-attr-override__editor--active">
          <Select
            className="acct-attr-override__select"
            autofocus
            openOnFocus
            value={revisedType}
            options={revisedTypeOptions}
            onChange={this.onChange}
          />
        </div>
      );
    }

    if (ignored) {
      return (
        <div className="acct-attr-override__editor">
          {revisedType && assetTypeToStrMap[revisedType]}
        </div>
      );
    }

    return (
      <div className="acct-attr-override__editor" onClick={this.toggleEditing.bind(this, true)}>
        {type !== AssetTypes.NegativeAsset && revisedType !== AssetTypes.NegativeAsset && (
          <Edit16 />
        )}
        {revisedType && ` ${assetTypeToStrMap[revisedType]}`}
      </div>
    );
  }

  render() {
    const { type, revisedType } = this.props;
    const emptyStyle = revisedType ? EMDASH : EMPTY_ACCOUNT_TYPE;
    return (
      <div className="acct-attr-override">
        <span style={{ textDecoration: revisedType ? "line-through" : "" }}>
          {type ? assetTypeToStrMap[type] : emptyStyle}
        </span>
        <br />
        {this.renderRevisedType()}
      </div>
    );
  }
}
